export default __webpack_public_path__ + "static/media/logo-ct-dark.2e1328f3.png";